<template>
	<div class="choose_pro">
		<el-dialog width="680px" title="选择商品" :visible.sync="show" :before-close="close" :close-on-click-modal="false">
			<div class="product-select">
				<div class="selector">
					<span class="label">商品分组</span>
					<el-select class="select-classify" v-model="classify_id" placeholder="请选择商品分组">
						<el-option v-for="item in classifys" :label="item.name" :value="item.id"></el-option>
					</el-select>
					<span class="label">商品名称</span>
					<div class="input-search el-input">
						<input type="text"
						  v-model="keyword"
						  @keyup.enter="search_product()"
						  autocomplete="off" maxlength="20" placeholder="请输入内容" class="el-input__inner">
					</div>
					<el-button class="btn" type="primary" @click="search_product()">查询</el-button>
					<el-button native-type="reset" @click="reset_search()">重置</el-button>
				</div>
				
			</div>
			<div v-if="goods.length > 0">
				<div class="pop-list">
					<el-radio-group v-model="goods_check" style="width: 100%;">
						<el-table
							:data="goods"
							height="300"
							style="width: 100%">
							<el-table-column
							  label="商品名称"
							  width="260">
							  <template slot-scope="scope">
								<div style="display: inline-block;">
									<img :src='scope.row.cover' class="pro_cover" />
									<div class="pro_tit" 
									style="text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden;word-break: break-word;">
									{{scope.row.title}}
									</div>
								</div>
							  </template>
							</el-table-column>
							<el-table-column
							  label="价格">
							  <template slot-scope="scope">
								<div class="price"><span>￥</span>{{scope.row.price}}</div>
							  </template>
							</el-table-column>
							<el-table-column
							  prop="statusText"
							  label="状态">
							</el-table-column>
							<el-table-column
							  prop="classify"
							  label="分组">
							</el-table-column>
							<el-table-column
							  label="操作">
							  <template slot-scope="scope">
								  <el-radio :label="scope.row.id">选择</el-radio>
							  </template>
							</el-table-column>
						  </el-table>
					  </el-radio-group>
				</div>
				<div style="display: flex;align-items: center;justify-content: space-between;">
					<!-- 分页器 -->
					<div class="block" style="padding: 30px 30px 10px 30px;" v-if="goods.length > 0"> 
						<el-pagination background align="center" @size-change="handleSizeChange"
							@current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
							layout="total, prev, pager, next" :pager-count="5" :total="total">
						</el-pagination>
					</div>
					<el-button style="width: 110px;margin-top: 20px;" type="primary" @click="add()" :disabled="goods_check == 0">确定</el-button>
				</div>
			</div>
			<div class="empty" v-else>
				<img src="@/assets/img/goods/empty_pop.png">
				<div>没有可选择的商品，您可前往商品库添加商品</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getDepotProductList,
		getProductClassify
	} from '@/api/goods';
	
	export default {
		data() {
			return {
				// tableData: [],
				keyword: '',
				currentPage: 0,
				loading: false,
				pageSize: 10, // 每页的数据条数
				total: 0,
				goods: [],
				goods_check: 0, // 选中的商品id
				classifys: [{name: '不限', id: 0}],
				classify_id: 0,
			}
		},
		props: {
			show: {
				type: Boolean,
				default: false
			},
			// 选中的商品id
			connectPid: {
				type: Number,
				default: 0
			}
		},
		watch:{
			show: function(newVal, oldVal){
				if(newVal){
					this.goods_check = this.connectPid;
					this.getClassify();
					this.getList();
				}
			}
		},
		methods: {
			// 搜索产品
			search_product(){
				this.currentPage = 1;
				this.getList();
			},
			getList() {
				let currentPage = this.currentPage;
				if (currentPage > 0) {
					currentPage = currentPage - 1;
				}
				getDepotProductList({
					classify: this.classify_id,
					start: currentPage * 10,
					keyword: this.keyword
				}).then(res => {
					if (res.code == 0) {
						this.loading = false;
						this.total = res.data.count;
						this.goods = res.data.list;
					} else {
						this.$message.error(res.message);
					}
				})
			},
			//每页条数改变时触发 选择一页显示多少行
			handleSizeChange(val) {
				this.currentPage = 1;
				this.pageSize = val;
			},
			//当前页改变时触发 跳转其他页
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getList();
			},
			close() {
				this.$emit('close');
			},
			// 确定
			add() {
				if (this.goods_check == 0) {
					return false;
				}
				var checkGoodsInfo = [];
				for (var i = 0;i < this.goods.length;i++) {
					if (this.goods_check == this.goods[i].id) {
						checkGoodsInfo = {
							pid: this.goods[i].id,
							name: this.goods[i].title,
							cover_url: this.goods[i].cover,
							cover:this.goods[i].file_id,
							retail_price: this.goods[i].price,
						};
						break;
					}
				}
				this.goods_check = 0;
				this.keyword = '';
				this.$emit('success',checkGoodsInfo);
			},
			// 获取分组
			getClassify() {
				getProductClassify({}).then(res => {
					if (res.code == 0) {
						this.classifys = this.classifys.concat(res.data);
					} else {
						this.$message.error(res.message);
					}
				})
			},
			// 重置按钮
			reset_search(){
				this.keyword = '';
				this.classify_id = 0;
				this.currentPage = 1;
				this.goods_check = 0;
				this.getList();
			}
		}
	}
	
</script>

<style scoped>
	.pro_cover{
		width: 40px;
		height:40px;
		border-radius: 2px;
		float: left;
		object-fit: cover;
	}
	.pro_tit{
		width: 186px;
		height: 40px;
		line-height: 20px;
		margin-left: 10px;
		float: left;
	}
	.product-select{
		margin-bottom: 20px;
	}
	.product-select .product-select-btn{
		width: 100px;
		color: #1989FA;
		background: #E6F1FC;
	}
	
	.goods_checkbox >>> .el-checkbox__label {
		display: none;
	}
	.goods_checkbox >>> .el-checkbox {
		padding: 11px 20px 11px 0;
	}
	
	.price {
		font-size: 14px;
		color: #F56C6C;
		line-height: 22px;
	}
	.btn {
		width: 68px;
		height: 40px;
		margin-left: 10px;
	}
	.btn-add, .btn-add:hover {
		border-color: #FF8700;
		background: #FF8700;
	}
	.selector {
		padding: 0 15px 15px 0;
		height: 40px;
		display: flex;
		align-items: center;
	}
	.label {
		margin: 0 10px;
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
	}
	.input-search {
		width: 157px;
	}
	.select-classify {
		width: 118px;
	}
	.empty {
		width: 100%;
		height: 500px;
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: center;
	}
	.empty img {
		width: 126px;
		height: 140px;
	}
	.empty div {
		font-size: 12px;
		font-weight: 500;
		color: #999999;
		line-height: 17px;
	}
	.choose_pro >>> .el-table th {
	    background-color: #F5F5F5;
	}
</style>